import React from 'react';

import * as styles from './Articles.css';

export default function DataRetention() {
  return (
    <div>
      <h1>Data Retention, Archival, and Destruction Policy</h1>
      <div className={styles.infoBlock}>
        <h2>Objective</h2>
        This Data Retention, Archival, and Destruction Policy has been adopted by Feathr and sets
        out the principles and procedures in which Feathr retains and destroys Feathr Application
        Data.
      </div>
      <div className={styles.infoBlock}>
        <h2>Definitions</h2>
        <ul>
          <li>
            <label>The Feathr Application</label> refers to the web application Feathr customers use
            to interact with and operate on Feathr data. Related Phrases ­ “The Platform”, “The
            App”, “app.feathr.co”
          </li>
          <li>
            <label>Feathr Data</label> refers to all data collected by any Feathr technology for use
            within the Feathr application.
          </li>
        </ul>
      </div>
      <div className={styles.infoBlock}>
        <h2>Scope</h2>
        This policy applies to all data used or retained for future use within the Feathr
        application. This includes any data provided by customers, as well as metadata required by
        the Feathr application. Additionally non­PII and PII generated from The Feathr Super Pixel
        is subject to the policies set forth in this document.
      </div>
      <div className={styles.infoBlock}>
        <h2>Data Categories</h2>
        For the purpose of this document Feathr Application Data is separated into five categories.
        Each category provides examples of data that fall within the boundaries of that category.
        These examples are provided for illustrative purposes and do not capture the full breadth of
        data within the respective category.
        <ul>
          <li>
            <label>Account Data</label>
            refers to data provided by customers and used within the Feathr application. This
            includes (but is not limited to) data on events, campaigns, partners, creative inventory
            as well as any other data used within the Feathr application.
          </li>
          <li>
            <label>Activity Data</label>
            refers to anonymous tracking data collected by the Feathr Super Pixel and any other
            activity tracking technologies utilized by the Feathr Platform. This includes (but is
            not limited to) website page views and clicks, ad views and clicks, or any other non­PII
            recordable DOM events.
          </li>
          <li>
            <label>Person Data</label>
            refers to a collection of PII and non­PII data representing a person to associate
            Activity Data with. This data is most commonly collected through customer uploads and
            tracked form submissions via the Feathr Super Pixel. This data includes (but is not
            limited to) name, email, date last seen, IP address, and custom data fields configured
            by the customer.
          </li>
          <li>
            <label>Metadata</label>
            refers to non­-PII information about other data categories. This includes (but is not
            limited to) application activity logs and application error logs.
          </li>
        </ul>
      </div>
      <div className={styles.infoBlock}>
        <h2>Data Retention</h2>
        All Feathr Application Data shall be retained only as long as it is useful, and will be
        promptly destroyed when it is no longer useful to Feathr or its customers.
        <ul>
          <li>
            <label>Account Data</label>
            will be retained only as long as the customer remains a client of Feathr. Should the
            customer terminate their relationship with Feathr or fail to renew their contract, all
            related Account Data will be promptly destroyed on the following business day. Backups
            of this data will be retained for up to 5 years after the deletion event.
          </li>
          <li>
            <label>Activity Data</label>
            Will be retained for a maximum of 7 years after the recorded activity. Should the
            customer terminate their relationship with Feathr or fail to renew their contract, all
            related Activity Data will be promptly destroyed as soon as possible with a maximum of 5
            business days after contract expiry. Backups of Activity Data will be retained for up to
            5 years after the deletion event.
          </li>
          <li>
            <label>Person Data</label>
            Will be retained for a maximum of 7 years after the last recorded activity for that
            person. Should the customer terminate their relationship with Feathr or choose to forgo
            a renewal of their contract, all related Person Data will be promptly destroyed as soon
            as possible with a maximum of 5 business days after contract expiry. Backups of Person
            Data will be retained for up to 5 years after the deletion event.
          </li>
          <li>
            <label>Metadata</label>
            Will be retained for a maximum of 5 years. Backups of Inferred Data will be retained for
            up to 5 years after the deletion event.
          </li>
        </ul>
      </div>
      <div className={styles.infoBlock}>
        <h2>Additional Information</h2>
        For a signed copy of this policy{' '}
        <a
          href={
            'https://s3.amazonaws.com/privacy-assets.feathr.co/Data+Retention%2C+Archival%2C+and+Destruction+Policy+-+Signed+Sheet.pdf'
          }
        >
          click here
        </a>
        .
      </div>
    </div>
  );
}
